module.exports = __webpack_public_path__ + "img/kv-prods.d96c5e6f.png";